import { ReactNode } from 'react';

import { x } from '@ui-furniture/style';

import outcodes from './data.json';

const checkHasNumber = (input: string) => /\d/.test(input);

export const createOutcodeRetrieverForAsyncSelect =
  (maxLength = 10) =>
  (inputValue: string) => {
    const upperCaseInputValue = inputValue.toUpperCase();
    const hasNumber = checkHasNumber(upperCaseInputValue);
    return new Promise<
      Array<{
        label: ReactNode;
        value?: (typeof outcodes)[number]['outcode'];
        isDisabled?: boolean;
      }>
    >((resolve) => {
      const matchingOutcodes = outcodes.filter(
        ({ outcode, areas }) =>
          outcode.startsWith(upperCaseInputValue) ||
          upperCaseInputValue.startsWith(outcode) ||
          /** Optimisation to not check areas if the input text has a number */
          (hasNumber
            ? false
            : areas.some((area) =>
                area.toUpperCase().startsWith(upperCaseInputValue)
              ))
      );

      const options = matchingOutcodes.slice(0, maxLength).map(
        ({ areas, outcode }) =>
          ({
            label: (
              <>
                {outcode}
                <x.span opacity={0.7}> - {areas.join(', ')}</x.span>
              </>
            ), // `${outcode} - ${area}`,
            value: outcode,
          } as {
            label: ReactNode;
            value?: (typeof outcodes)[number]['outcode'];
            isDisabled?: boolean;
          })
      );
      if (matchingOutcodes.length > maxLength)
        options.push({
          label: `Showing ${maxLength} of ${matchingOutcodes.length} results - Type to filter more`,
          isDisabled: true,
        });
      resolve(options);
    });
  };
